import { addEmployeeUrl,getAllEmpUrl,singleEmployeeUrl,updateEmployeeUrl, singleExpenseEmployeeUrl, dailyReportUrl, addSalaryUrl } from "../api";
import {customAxios as axios, getToken} from "../../../request";
import notification from "../../../components/Elements/Notification";
import {hideLoader, showLoader} from "../../../actions/loader";

export const fetchAllEmp = async (valData) => {
    let config = {
        params: {...valData},
        ...await getToken()
    }
    const {data} = await axios.get(getAllEmpUrl(), config);
    return data;
};

export const addEmployeeFxn = (valData) => async (dispatch) => {
    dispatch(showLoader())
    const {data} = await axios.post(addEmployeeUrl(), valData, getToken());
    dispatch(hideLoader())
    if (!data.error) {
        notification.success({message: data.message || "Success"})
    } else {
        notification.error({message: data.message || "Error"})
    }
    return data;
};

export const singleEmployeeFxn = (id) => async (dispatch) => {
    dispatch(showLoader());
    
    let { data } = await axios.get(singleEmployeeUrl(id));
    console.log(data);
    dispatch(hideLoader());
    if (data.error) {
      notification.error({
        message: data.message || "Error",
      });
    }
  
    return data;
  };

  export const singleExpenseEmployeeFxn = (id) => async (dispatch) => {
    dispatch(showLoader());
    
    let { data } = await axios.get(singleExpenseEmployeeUrl(id) , getToken());
    console.log(data);
    dispatch(hideLoader());
    if (data.error) {
      notification.error({
        message: data.message || "Error",
      });
    }
  
    return data;
  };


  export const dailyReportFxn = (id) => async (dispatch) => {
    dispatch(showLoader());
    
    let { data } = await axios.get(dailyReportUrl(id) , getToken());
    console.log(data);
    dispatch(hideLoader());
    if (data.error) {
      notification.error({
        message: data.message || "Error",
      });
    }
  
    return data;
  };
  export const fetchAllExpense = async (valData) => {
    let config = {
        params: {...valData},
        ...await getToken()
    }
    const {data} = await axios.get(singleExpenseEmployeeUrl(), config);
    return data;
};

  export const updateEmployeeFxn = (valData) => async (dispatch) => {
    dispatch(showLoader());
    let {data} = await axios.post(updateEmployeeUrl(), valData ,getToken());
    dispatch(hideLoader());
    if (data.error) {
        notification.error({
            message: data.message || "Error",
        });
    } else {
        notification.success({
            message: data.message || "Success",
        });
    }
    return data;
  };
  export const addSalaryFxn = (valData) => async (dispatch) => {
    dispatch(showLoader());
    const { data } = await axios.post(addSalaryUrl(), valData, getToken());
    dispatch(hideLoader());
    if (!data.error) {
    } else {
      notification.error(data.message || "Error");
    }
    return data;
  };